<template>
  <v-dialog scrollable v-model="dialog" persistent max-width="800">
    <material-card
      :title="$t('components.memberview.self_payment_title')"
      icon="person_add_alt"
      :color="$vuetify.theme.themes.light.success"
      v-if="dialog"
    >
      <v-card-text>
        <v-container>
          <v-row v-if="item !== null && item !== undefined">
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.selfpayments.payment_date") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatDate(item.PaymentDate) }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.eligibility_bank.calendar_year") }}
              <br />
              <span class="minfo">
                {{ item.CalendarYear }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.eligibility_bank.calendar_month") }}
              <br />
              <span class="minfo">
                {{ item.CalendarMonth }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.amount") }}
              <br />
              <span class="minfo">
                {{ item.Amount }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.selfpayments.deposited") }}
              <br />
              <span class="minfo">
                {{ item.Deposited ? "Yes" : "No" }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.type") }}
              <br />
              <span class="minfo">
                {{ $t(`enums.${item.Type}`) }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("views.planbalance.cheque_number") }}
              <br />
              <span class="minfo">
                {{ item.PaymentNumber }}
              </span>
            </div>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color text @click="$emit('close')">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";

export default {
  components: {
    ErrorHandler,
  },
  props: ["id", "dialog", "memberIdentityId"],
  data() {
    return {
      error: undefined,
      item: null,
    };
  },
  watch: {
    dialog: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["user"]),
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("plansMembers", ["getSelfPaymentById"]),
    async loadData() {
      console.log("loadData")
      if (this.id !== null && this.id !== undefined) {
        try {
          this.item = (
            await this.getSelfPaymentById({
              planIdentityId: this.selectedPlan.Id,
              memberIDentityId: this.memberIdentityId,
              id: this.id,
            })
          ).data.value[0]
          console.log("##############",this.id, this.item);
        } catch (error) {
          this.error = error;
        }
      }
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>